import { Switch, Route, Redirect } from 'react-router-dom';
import React from 'react';
import loadRoute from 'launch/components/loadRoute';

const LogoDesign = ({ match, location }) => (
    <Switch>
        <Route
            path={`${match.url}/designs`}
            component={loadRoute(done => require(['launch/components/BriefStyleSelector'], done), {
                withStyleAssessment: true,
            })}
        />
        <Route
            path={`${match.url}/attributes`}
            component={loadRoute(done =>
                require(['launch/containers/BriefStyleAttributesWithEmailCollection'], done)
            )}
        />
        <Route
            path={`${match.url}/colors`}
            component={loadRoute(done => require(['launch/components/BriefStyleColors'], done))}
        />
        <Redirect from="*" to={{ ...location, pathname: `${match.url}/designs` }} />
    </Switch>
);

export default LogoDesign;



// WEBPACK FOOTER //
// ./js/launch/routes/LogoDesign.jsx